import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import React, { FunctionComponent } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import * as storage from '../util/StorageUtil';
import { loginRequest } from "../util/authUtil";
import { useNavigate } from "react-router-dom";
import { makeLogEvent } from '../api/EventLog';


export const SignButton: FunctionComponent = () => {

  const { instance } = useMsal();
  const navigate = useNavigate();

    const signIn = async () => {
      try {
        storage.clearStore(); // Forgot last user and other data...
        await instance.loginPopup(loginRequest);
        navigate("/home", { replace: true });
      } catch (error) {
        //login failure
        console.log(error);
      }
    }

  const signOut = async () => {
      const account = instance.getActiveAccount();
      const name = account?.name;
      const role = account?.idTokenClaims?.roles ? account?.idTokenClaims?.roles[0] : "none";
      await makeLogEvent(`User ${name} logged out`, "login", `Role: ${role}`);
      storage.clearStore(); // Forgot last user and other data...
      const logoutRequest = {
        account
      }
      await instance.logoutRedirect(logoutRequest).catch((error) => console.log(error));
    }

    return (
      <>
        <AuthenticatedTemplate>
            <div className="login ms-xl-5 ms-4">
                <Button className="btn btn-primary" onClick={() => signOut()} >
                    <FormattedMessage id="desktop.logout" />
                    <i className="fa fa-sign-out ml-2" aria-hidden="true"></i>
                </Button>
            </div>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <div className="login ms-xl-5 ms-4">
                <Button className="btn btn-primary" onClick={() => signIn()} >
                    <FormattedMessage id="login.loginbutton" />
                    <i className="fa fa-sign-in ml-2" aria-hidden="true"></i>
                </Button>
            </div>
        </UnauthenticatedTemplate>
      </>
    );
};